

export default {
  root: {
    '@media(min-width: 600px)': {
      minHeight: '48px',
    },
  },
}
